module.exports = __webpack_public_path__ + "themes/mf/font/SignPainter-HouseScript.ttf";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/SignPainter-HouseScript.ttf
// module id = 135
// module chunks = 3